<div class="payment-complete">
  <div>
    <p *ngIf="!errorState && loadingState">Checking order state...</p>
    <p *ngIf="!errorState && !loadingState">Order Successfully Completed</p>
    <p *ngIf="errorState"><span style="margin-right: 10px;" nz-icon nzType="ng-zorro:cancel"></span>Order Cancelled</p>
    <p style="font-size: 28px;">{{ orderCode }}</p>
  </div>
  <div class="result-icon-container">
    <span *ngIf="!errorState && !loadingState" nz-icon nzType="ng-zorro:shopping"></span>
  </div>
  <div class="button-container">
    <button nz-button nzType="primary" type="submit" class="inventory_button">
      Open Inventory
    </button>
  </div>
</div>